module.exports = __webpack_public_path__ + "static/media/fix_mclaren.885f3d41.png";